'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronDown } from 'lucide-react';
import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
type FAQAccordionProps = {
  question: string;
  answer: string | ReactNode;
  index: number;
};
function FAQAccordion(t0) {
  const $ = _c(16);
  const {
    index,
    question,
    answer
  } = t0;
  const t1 = index % 2 !== 0;
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex items-center gap-4 lg:gap-6", {
      "flex-row-reverse": t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `faq-${index}`;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bg-vive-primary-70 grid size-8 place-items-center rounded-full md:size-[52px]"><ChevronDown className="stroke-vive-primary-30 size-[24px] transition-all" /></div>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== question) {
    t5 = <AccordionTrigger className="md:header-4 subheader-1 text-vive-primary-20! 1.5xl:px-6 1.5xl:py-[34px] rounded-2xl p-4 py-2 text-start hover:no-underline data-[state=open]:text-white! max-lg:gap-4 md:rounded-3xl md:py-8 md:font-medium [&[data-state=open]>div>svg]:rotate-180" toggleComponent={t4}><p className="flex-1">{question}</p></AccordionTrigger>;
    $[3] = question;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      hidden: {
        opacity: 0
      },
      visible: {
        opacity: 1
      }
    };
    t7 = {
      duration: 1
    };
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] !== answer) {
    t8 = <AccordionContent className="subheader-1 1.5xl:px-6 1.5xl:py-[34px] 1.5xl:pt-0 px-4 py-2 pt-0 md:py-8 md:font-medium"><motion.div className="text-vive-primary-30! w-full flex-1" initial="hidden" animate="visible" exit="hidden" variants={t6} transition={t7}>{answer}</motion.div></AccordionContent>;
    $[7] = answer;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t3 || $[10] !== t5 || $[11] !== t8) {
    t9 = <AccordionItem value={t3} className="from-vive-primary-80 via-vive-primary-80 to-primary flex w-full flex-col rounded-2xl border-none bg-linear-to-r bg-[length:200%] bg-left duration-700 hover:bg-[length:200%] hover:bg-right data-[state=open]:bg-[length:200%] data-[state=open]:bg-right md:rounded-3xl">{t5}{t8}</AccordionItem>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t2 || $[14] !== t9) {
    t10 = <Accordion type="single" collapsible={true} className={t2}>{t9}</Accordion>;
    $[13] = t2;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}
export default FAQAccordion;